import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, Popover, message } from "antd";
import { find } from 'lodash';

import * as constants from '../../constants';
import ProcessedDataForm from './ProcessedDataForm';

import core from '../../../core';
import uistate from '../../../uistate';
import globalappstate from '../../../globalappstate';
import common from '../../../../common';

const { GenericTable } = core;


class ProcessedDataGrid extends Component {

    state = {
        addFormVisible: false,
        editFormVisible: false,
        currentEditEntity: {},
    };

    label = (key) => {
        return common.getLabel(this.props.labels, constants.NAME, 'ProcessedDataGrid', key);
    }

    //#region Grid button handlers

    onAddClicked = (e) => {
        this.setState({
            currentEditEntity: { idProcessingActivity: this.props.idProcessingActivity, idProcessedData: -1, securityMeasures:[] },
            addFormVisible: true,
        });
    }
    onDeleteClicked = (idx) => {
        this.props.arrayHelper.remove(idx);
    }
    onEditClicked = (id) => {
        const editentity = find(this.props.items, { 'idx': id });
        this.setState({
            currentEditEntity: editentity,
            editFormVisible: true,
        });
    }
    //#endregion    

    //#region Form handlers

    handleCancelForm = (e) => {
        this.setState({
            addFormVisible: false,
            editFormVisible: false,
            currentEditEntity: {},
        });
    }
    handleEntityAdd = (values) => {
        this.props.arrayHelper.push(values);
        this.setState({
            addFormVisible: false,
            currentEditEntity: {},
        });
    }
    handleEntityEdit = (values) => {
        this.props.arrayHelper.replace(values.idx, values);
        this.setState({
            editFormVisible: false,
            currentEditEntity: {},
        });
    }
    //#endregion

    render() {
        const readOnly = this.props.readOnly ? this.props.readOnly : false;
        const columns = [{
            title: this.label('Description'),
            dataIndex: 'description',
            key: 'description',
            sorter: (a, b) => ('' + a.description).localeCompare(b.description),
        },{
            title: this.label('ItSystemOrStorageLocation'),
            dataIndex: 'itSystemOrStorageLocation',
            key: 'itSystemOrStorageLocation',
            sorter: (a, b) => ('' + a.itSystemOrStorageLocation).localeCompare(b.itSystemOrStorageLocation),
        },{
            title: this.label('DataCategoryName'),
            dataIndex: 'dataCategoryName',
            key: 'dataCategoryName',
            sorter: (a, b) => ('' + a.dataCategoryName).localeCompare(b.dataCategoryName),
        },{
            title: this.label('SecurityMeasures'),
            dataIndex: 'securityMeasures',
            key: 'securityMeasures',
            render: measures => (
                <ul>
                  {measures.map(m => {
                    return (
                      <li key={m.id}>
                        {m.name ? m.name : m.nameSecurityMeasure }
                      </li>
                    );
                  })}
                </ul>
              ),
            //sorter: (a, b) => ('' + a.description).localeCompare(b.description),
        }];

        return (
            <div className='processeddata'>
                <GenericTable aligntop multiline columns={columns} data={this.props.items} keyfield='idx' itemName={this.label('ProcessedDataItem')} pagesize={5}
                    onAdd={this.onAddClicked}
                    readOnly={readOnly}
                    onDelete={this.onDeleteClicked} 
                    onEdit={this.onEditClicked}
                    onDoubleClick={this.onEditClicked} />

                <Modal title={this.label("AddModalTitleForm")} width='80%' destroyOnHidden={true} maskClosable={false}
                    open={this.state.addFormVisible}
                    footer={null}
                    onCancel={this.handleCancelForm}
                >
                    <ProcessedDataForm picklists={this.props.picklists} labels={this.props.labels} datacontext={this.state.currentEditEntity} onCancel={this.handleCancelForm} onSave={this.handleEntityAdd} />
                </Modal>
                <Modal title={this.label("EditModalTitleForm")} width='80%' destroyOnHidden={true} maskClosable={false}
                    open={this.state.editFormVisible}
                    footer={null}
                    onCancel={this.handleCancelForm}
                >
                    <ProcessedDataForm picklists={this.props.picklists} labels={this.props.labels} datacontext={this.state.currentEditEntity} onCancel={this.handleCancelForm} onSave={this.handleEntityEdit} />
                </Modal>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        picklists: globalappstate.selectors.allPicklists(state),
        labels: uistate.selectors.uiLabels(state),
    };
}

export default connect(mapStateToProps,
    {

    })
    (ProcessedDataGrid);  